export default [
    {
        path: 'inventario',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-inventario' */
            '@/views/almoxarifado/inventario/Index'
        ),
        redirect: 'inventario/index',
        children: [
            {
                name: 'almoxarifado-inventario-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-inventario' */
                    '@/views/almoxarifado/inventario/List.vue'
                ),
            },
        ],
    },
]